<template>
<div>
    <div id="wrapper">
        <template v-if="$route.query.headShow === '1'">
            <div class="header" :style="{'padding-top':headHeight + 'px'}">
                <div class="header-left" @click="goBack"><img src="../../assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main">订单详情</div>
                <div class="header-right"></div>
            </div>
            <div class="header-pre" :style="{'padding-top':headHeight + 'px'}"></div>
        </template>
         <!--banner区域 -->
        <div :class="['statusContent', bgName]">
            <div class="text">
                <div class="status">{{result.orderStatus}}</div>
                <div v-if="result.orderStatus === '退款成功' || result.orderStatus === '退款失败' || result.orderStatus === '退款中'" class="refundInfo" @click="show = true"><span>退款信息 &nbsp;&nbsp;</span><van-icon name="arrow" /></div>
                <div v-if="result.orderStatus === '待支付' || result.orderStatus === '待激活'" class="refundInfo">{{`将于${hour}小时${min}分钟后自动取消`}}</div>
            </div>
        </div>
        <!-- 用户信息 -->
        <div class="userInfo">
            <div class="leftIcon">
                <div class="icon"></div>
            </div>

            <div class="rightInfo">
                <van-skeleton title :row="3" :loading="loading">
                    <div class="top">
                        <span class="name">{{result.receiverName}}</span>
                        <span class="phone">{{result.receiverMobile}}</span>
                    </div>
                    <div>
                        <span class="address">{{result.receiverAddress}}</span>
                    </div>
                </van-skeleton>
            </div>

        </div>
        <!-- 商品信息 -->
        <div class="goodsInfo">
            <h5 class="label">商品信息</h5>

            <van-skeleton title :row="4" :loading="loading">
                <section class="top" >
                        <div class="image"><img class="img" :src="result.goodsPic" /></div>
                        <div class="right-box">
                            <div class="goods-name">{{result.goodsName}}</div>
                            <div class="other-name">{{result.goodsPriceCartModel}}</div>
                            <div class="price">
                                <div>¥{{result.goodsSalePrice}}/{{result.goodsHours}}小时</div>
                                <div>*{{result.goodsPriceNumber}}</div>
                            </div>
                            <div class="remark">{{result.priceRemark}}</div>

                        </div>
                </section>
            </van-skeleton>

            <section class="bottom">
                <van-skeleton title :row="6" :loading="loading">
                <div class="row">
                    <div class="label">配送方式</div>
                    <div class="content">
                      免运费
                    </div>
                </div>
                <div class="row">
                    <div class="label">支付方式</div>
                    <div class="content">
                        {{result.paymentType}}
                    </div>
                </div>
                <div class="row">
                    <div class="label">付款金额</div>
                    <div class="content">
                        <div><span style="color: #FF5050">{{result.paymentType === '激活码' ? '¥0' :  (result.orderAmount >= 0 ? `¥${result.orderAmount}` : '-')}}</span></div>
                    </div>
                </div>
                <div class="row">
                    <div class="label">订单编号</div>
                    <div class="content">
                        {{result.orderNo}}
                    </div>
                </div>
                <div class="row">
                    <div class="label">下单时间</div>
                    <div class="content">
                        {{result.orderTime}}
                    </div>
                </div>
                <div class="row" v-if="result.payTime">
                    <div class="label">支付时间</div>
                    <div class="content">
                        {{result.payTime}}
                    </div>
                </div>
                <div class="row hre" v-if="!((result.orderStatus === '已取消' && !result.coachName ) || (result.orderStatus === '待付款' && !result.coachName ))">
                  <div class="label">陪驾教练</div>
                  <div class="content">
                    {{result.coachName || '——'}}
                  </div>
                </div>
                <div class="row" v-if="!((result.orderStatus === '已取消' && !result.coachMobile ) || (result.orderStatus === '待付款' && !result.coachMobile ))">
                  <div class="label">联系电话</div>
                  <div class="content">
                    <span v-if="result.coachMobile" @click="call(result.coachMobile)">{{result.coachMobile}}</span>
                    <span v-else> —— </span>
                  </div>
                </div>
                </van-skeleton>
            </section>

        </div>
        <div class="footer-pre"></div>
        <!-- 底部按钮区 -->
        <footer class="footer" v-if="result.showPayBtn || result.showCancelBtn || result.showRefundBtn || result.showEvaluateBtn || result.showRevokeRefundBtn || result.showActiveBtn">
          <van-button v-if="result.showPayBtn || result.showActiveBtn" class="button" type="default" :loading="payLoading" @click="pay">{{result.paymentType === '在线支付'?  '立即支付' : '立即激活'}}</van-button>
          <van-button v-if="result.showCancelBtn" class="button" type="default" :loading="cancelLoading" @click="cancel">取消订单</van-button>
          <van-button v-if="result.showRefundBtn" class="button" type="default" :loading="refundLoading" @click="refund">申请退款</van-button>
          <van-button v-if="result.showRevokeRefundBtn" class="button" type="default" :loading="refundLoading" @click="resetRefund">撤销退款</van-button>
          <van-button v-if="result.showEvaluateBtn" class="button" type="default" :loading="refundLoading" @click="evaluate">{{result.evaluateFlag ? '已评价': '评价'}}</van-button>
        </footer>
        <!-- 弹窗 -->
        <van-action-sheet class="refund-popup" v-model="show" title="退款信息">
            <div class="dialogwrap">
                <div class="row">
                    <div class="label">申请时间</div>
                    <div class="content">
                        {{result.refundAskTime}}
                    </div>
                </div>
                <div class="row">
                  <div class="label">退款金额</div>
                  <div class="content">
                    {{result.refundAmount}}
                  </div>
                </div>
                <div class="row">
                    <div class="label">退款审核</div>
                    <div class="content red">
                        {{result.auditFlag}}
                    </div>
                </div>
                <div class="row">
                    <div class="label">审核时间</div>
                    <div class="content">
                        {{result.auditTime}}
                    </div>
                </div>
              <div class="row">
                <div class="label">备注</div>
                <div class="content">
                  {{result.remark}}
                </div>
              </div>
            </div>
        </van-action-sheet>
        <ctl-dialog v-model="dialogData" :dialogStyle="dialogStyle" :loading="loading">
          <div slot="content" class="password-input">
            <ul @click="clickInput">
              <li v-for="v in 6" :key="v">{{value[v - 1]}}</li>
            </ul>
            <input ref="input" type="text" v-model="value" maxlength="6"/>
          </div>
        </ctl-dialog>
        <ctl-dialog v-model="messageDialog" :loading="loading"/>
    </div>
</div>
</template>
<script>
import { Skeleton, Button, Icon, ActionSheet, Toast } from 'vant'
import { setInterval, clearInterval } from 'timers'
import dialog from '@/components/dialog/index'
export default {
    components: {
        [Skeleton.name]: Skeleton,
        [Button.name]: Button,
        [Icon.name]: Icon,
        ctlDialog: dialog,
        [ActionSheet.name]: ActionSheet
    },
    data () {
        return {
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            dialogStyle: { marginBottom: '' },
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            value: '',
            timer: null,
            overTime: '', // 截止时间
            hour: '',
            min: '',
            showBandou: false,
            show: false,
            payLoading: false,
            cancelLoading: false,
            refundLoading: false,
            loading: true,
            bgName: 'payment',
            imgUrl: '', // 商品信息里的左侧图片url
            status: '',
            result: {},
            userInfo: {
                name: '',
                phone: '',
                address: ''
            },
            goodsInfo: {
                name: '',
                price: '',
                num: ''
            },
            id: '',
            headHeight: 0,
            detailList: [],
            refundInfo: {}
        }
    },
    methods: {
        // 拨打客服电话
        call (v) {
            this.$jsBridge.callBackHandler('callPhone', { tel: v })
        },
        // 返回
        goBack () {
            this.$router.back()
        },
        // 点击输入框事件
        clickInput () {
            this.$refs.input.focus()
        },
        parseTime () {
            let currentTime = parseInt(new Date().getTime() / 1000) // 当前时间 秒数
            if (currentTime >= this.overTime) { // 当前系统时间大于截止时间， 清除定时器并阻断
                clearInterval(this.timer)
                this.loading = true
                this.hour = '0'
                this.min = '1'
                this.$api.cancelOrder({ orderId: this.id, orderType: 6 }).then(res => {
                    if (res.status) {
                        this.getData()
                    }
                    this.loading = false
                })
                return
            }
            this.hour = parseInt((this.overTime - currentTime) / 3600) // 转成小时单位
            this.min = parseInt(((this.overTime - currentTime) % 3600) / 60) || 1 // 取余后剩下的秒数就是分钟的， 再除以60就是分钟了
        },
        getData () {
            this.$api.getDetailsPeijia({ orderId: this.id }).then(res => {
                if (res.status) {
                    res.result.orderTime = res.result.orderTime ? this.moment.formatTime(res.result.orderTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.payTime = res.result.payTime ? this.moment.formatTime(res.result.payTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.cancelTime = res.result.cancelTime ? this.moment.formatTime(res.result.cancelTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.auditTime = res.result.auditTime ? this.moment.formatTime(res.result.auditTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.refundAskTime = res.result.refundAskTime ? this.moment.formatTime(res.result.refundAskTime, 'YYYY-MM-DD HH:mm:ss') : ''

                    this.result = res.result
                    this.overTime = parseInt(new Date(res.result.orderTime.replace(/-/g, '/')).getTime() / 1000) + 1800 // 截止时间 秒数
                    clearInterval(this.timer)
                    if (this.overTime && (this.result.orderStatus === '待支付' || this.result.orderStatus === '待激活')) {
                        this.parseTime()
                        this.timer = setInterval(this.parseTime, 60000)
                    }
                }
                this.loading = false
            })
        },
        refund () {
            this.$router.push({ name: 'refundPeijia', query: { id: this.id } })
        },
        evaluate () {
            let data = {
                ids: [this.id],
                terminalType: 1
            }
            if (this.result.evaluateFlag) {
                this.$router.push({ name: 'evaluatePeijia', query: { id: this.id, coachName: this.result.coachName, coachMobile: this.result.coachMobile } })
                return
            }
            if (this.result.orderStatus === '已分配' || this.result.orderStatus === '退款失败') {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '已完成',
                    leftBtnName: '未完成',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.$api.finishPeijia(data).then(res => {
                            if (res.status) {
                                this.$router.push({ name: 'evaluatePeijia', query: { id: this.id, coachName: this.result.coachName, coachMobile: this.result.coachMobile } })
                            }
                        })
                    },
                    title: '提示',
                    content: '您的陪驾服务是否已全部完成？'
                }
            } else if (this.result.orderStatus === '已完成') {
                this.$router.push({ name: 'evaluatePeijia', query: { id: this.id, coachName: this.result.coachName, coachMobile: this.result.coachMobile } })
            } else {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '已完成',
                    leftBtnName: '未完成',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.$router.push({ name: 'evaluatePeijia', query: { id: this.id, coachName: this.result.coachName, coachMobile: this.result.coachMobile } })
                    },
                    title: '提示',
                    content: '您的陪驾服务是否已全部完成？'
                }
            }
        },
        resetRefund () {
            this.messageDialog = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.messageDialog.visible = false
                    this.$api.revertRefundApplypeijia({ orderId: this.id }).then(res => {
                        if (res.status) {
                            this.getData()
                        }
                    })
                },
                title: '提示',
                content: '是否撤销退款申请？'
            }
        },
        pay () {
            if (this.result.paymentType === '激活码') {
                this.dialogData = {
                    visible: true,
                    rightBtnName: '立即激活',
                    leftBtnName: '取消',
                    leftBtnMethod: () => {
                        this.dialogData.visible = false
                    },
                    rightBtnMethod: () => {
                        if (this.value === '') {
                            Toast.fail('激活码不能为空')
                            return
                        }
                        this.loading = true
                        this.$api.activePeijia({ activeCode: this.value, orderId: this.id }).then(res => {
                            this.loading = false
                            if (res.code === '200' && res.status) {
                                this.dialogData.visible = false

                                Toast.success('激活成功')
                                setTimeout(() => {
                                    this.$router.replace(`/peijia/orderDetail?id=${this.id}&headShow=${this.$route.query.headShow}`)
                                }, 1000)
                            } else if (res.result) {
                                Toast.fail(res.result)
                            } else {
                                Toast.fail(res.message)
                            }
                        })
                    },
                    title: '输入6位激活码',
                    content: ''
                }
            } else {
                this.$router.replace({ name: 'pay', query: { id: this.id, payId: this.id, money: this.result.orderAmount, type: '6', headShow: this.$route.query.headShow } })
            }
        },
        cancel () {
            this.messageDialog = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.messageDialog.visible = false
                    this.$api.cancelOrder({ orderId: this.id, orderType: 6 }).then(res => {
                        if (res.status) {
                            this.getData()
                        }
                        this.loading = false
                    })
                },
                title: '提示',
                content: '是否确认取消该订单？'
            }
        }
    },
    created () {
        this.id = this.$route.query.id
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
  *{
    word-break: break-all;
  }
    .header{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        z-index: 9999;
        justify-content: space-between;
        height: 60px;
        background: #ffffff;
        .header-main{
            font:bold 18px PingFangSC;
            color: #333333;
        }
        .header-left,.header-right{
            display: flex;
            padding: 15px 10px;
            font-size: 0;
            line-height: 1;
            width: 24px;
            img{
                width: 24px;
                height: 24px;
            }
        }
    }
    .footer-pre{
      height: 50px;
    }
    .header-pre{
        height: 60px;
    }
    #wrapper{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: absolute;
        background: #fafafa;
    }
    .payment{ // 待付款
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
    }
    .beshipped{ // 待发货
        background: url('~@/assets/order/bg_to_be_shipped.png') no-repeat center;
    }
    .shipped{ // 已发货
        background: url('~@/assets/order/bg_shipped.png') no-repeat center;
    }
    .completed{ // 已完成
        background: url('~@/assets/order/bg_completed.png') no-repeat center;
    }
    .refund{ // 退款中
        background: url('~@/assets/order/bg_refund.png') no-repeat center;
    }
    .cancelled{ // 已取消
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
    }
    .shippedInfo{
        margin-top: 7px;
        font: 400 14px PingFangSC-Regular;
        color: rgba(51,51,51,1);
        div{
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .statusContent{
        height: 100px;
        background-size: 100%;
        position: relative;
        .text{
            position: absolute;
            top: 26px;
            left: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 45px;
        }
        .status{
            font: 600 24px PingFangSC-Semibold;
            color: rgba(51,51,51,1);
        }
        .refundInfo{
            display: flex;
            align-items: center;
            padding-top: 10px;
            font: 400 14px PingFangSC-Regular;
            color: rgba(51,51,51,1);
        }
    }
    .userInfo{
        display: flex;
        background: white;
        min-height: 80px;
        margin-bottom: 10px;
        .leftIcon{
            position: relative;
            width: 60px;
            .icon{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 24px;
                height: 24px;
                background: url('~@/assets/public/icon_address_yellow@2x.png') no-repeat;
                background-size: 100%;
            }
        }
        .rightInfo{
            box-sizing: border-box;
            width: 306px;
            padding: 17px 0 ;
            .top{
                display: flex;
                align-items: center;
                padding-bottom: 4px;
            }
            .name{
                display: inline-block;
                padding-right: 10px;
                color: #333333;
                font: 600 18px PingFangSC-Semibold;
            }
            .phone{
                font: 400 14px PingFangSC-Regular;
                color:rgba(51,51,51,1);
            }
            .address{
                font: 400 14px PingFangSC-Regular;
                color:rgba(51,51,51,1);
                word-wrap: break-word;
            }
        }
    }
    .password-input{
      position: relative;
      margin-top: 20px;
      input{
        opacity:0;
        height: 100px;
        width: 100px;
        border: none;
        position: absolute;
        left: -100%;
      }
      ul{
        justify-content: center;
        display: flex;
        align-items: center;
        text-align: center;
        li{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border:1px solid #cccccc;
          font: 600 24px PingFangSC;
          color:#333333;
          &+li{
            border-left:none;
          }
        }
      }
    }
    .goodsInfo{
        background: white;
        padding: 20px 15px 0;
        .label{
            font: 400 14px PingFangSC-Regular;
            color:rgba(102,102,102,1);
        }
        .top{
            display: flex;
            padding: 10px 0 6px;
            align-items: center;
            .image{
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                line-height: 1;
                font-size: 0;
                img{
                    width: 100%;
                }
            }
            .right-box{
                margin-left: 15px;
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;
                .goods-name{
                    font: 600 15px PingFangSC-Regular;
                    color:#333333;
                    word-wrap: break-word;
                }
                .other-name{
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: fit-content;
                  margin: 10px 0 0 0;
                  padding: 0 5px;
                  box-sizing: border-box;
                  height: 20px;
                  border-radius: 3px;
                  border: 1px solid #666666;
                  font: 400 14px PingFangSC-Regular, PingFang SC;
                  color: #666666;
                }
                .price{
                    line-height: 1;
                    display: flex;
                    justify-content: space-between;
                    padding-top: 8px;
                    font-size: 14px;
                    color: #666666;
                }
                .remark{
                    margin: 8px 0 0 0;
                    font-size: 12px;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }
        // .bottom{
        // }
    }
    .footer{
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #eeeeee;
        background: white;
        box-sizing: border-box;
        padding:  14px 15px;
        .button{
            width: 90px;
            height: 24px;
            margin: 2px;
            line-height: 24px;
            font-size: 14px;
            border-radius: 3px;
            border:1px solid rgba(204,204,204,1);
        }
    }
    .dialogwrap{
        padding: 15px;
    }
    .refund-popup{
      /deep/ .van-action-sheet__header{
        font: 600 18px/64px PingFangSC-Semibold, PingFang SC;
        color: #333333;
      }
    }
    .row{
        &.hre{
          border-top: 1px solid #EEEEEE;
        }
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        .label{
            min-width: 100px;
            font: 400 14px PingFangSC-Regular;
            color:rgba(102,102,102,1);
        }
        .content{
            &.red{
              color: #FF5050;
            }
            word-break: break-word;
            font: 400 14px PingFangSC-Regular;
            color:rgba(51,51,51,1);
        }
    }

</style>
